/**
 * Policy enforcement: employees whose HOME country (per the Amazonian profile)
 * is in this list must return their old device to receive a new one. Derived
 * from the Amazonian's home country, never from the shipping address, so a
 * user cannot bypass the rule by changing the shipping destination.
 */
export const RETURN_DEVICE_COUNTRIES = ["CRI", "IND"];
